<wtf-dialogcontent [size]="'md'" class="mat-dialog-content-form-programado" [dialogTitle]="dialogTitle"
    (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->
    <div fxLayout="row" fxLayoutAlign="end center" class="mt-24">
        <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
    </div>
    <mat-horizontal-stepper class="mt-24 mb-24" linear="true" #stepper>
        <mat-step [stepControl]="firstFormGroup">
            <form fxLayout="column" [formGroup]="firstFormGroup">
                <ng-template matStepLabel>{{
                    "Info Campaña" | translate
                    }}</ng-template>
                <mat-label>{{ "Nombre de la Campaña" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                        [readonly]="action === recordAction.View" required />
                </mat-form-field>
                <mat-label>{{ "template" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-select [compareWith]="compareFn" (selectionChange)="onSelect($event)" name="template"
                        formControlName="template" placeholder="">
                        <mat-form-field>
                            <input #searchInput matInput placeholder="Search..." (keyup)="onKey($event.target)"
                                (keydown)="$event.stopPropagation()" />
                        </mat-form-field>
                        <mat-option *ngFor="let template of smsFilteredTemplates" [value]="template">{{
                            template.name
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-label>{{ "Codigo Corto" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-select [compareWith]="compareFn" style="border-top-width: 0px !important" name="shortcode"
                        formControlName="shortcode" placeholder="">
                        <mat-option *ngFor="let shortCode of shortCodes" [value]="shortCode">{{
                            shortCode.operator.name +
                            " - " +
                            shortCode.value
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-label>{{ "Grupos" | translate }}</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-select [compareWith]="compareFn" name="grupo" formControlName="grupo" placeholder="" multiple>
                        <mat-option *ngFor="let grupo of grupos" [value]="grupo">{{ grupo.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <!--     <mat-form-field class="w-100-p">
                    <input matInput name="service_type" formControlName="service_type" mat-maxlength="50" placeholder="Identificador de Campaña"
                        [readonly]="action===recordAction.View">
                </mat-form-field>-->
                <mat-label>{{ "Mensaje" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <textarea matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                        formControlName="message" placeholder=""></textarea>
                </mat-form-field>
                <mat-hint align="start">{{ input.value?.length || 0 }}/150
                    {{ "caracteres" | translate }}</mat-hint>
                <mat-checkbox name="instantaneo" [checked]="hideMessage" (change)="onChangeHideMessage($event)">{{
                    "Ocultar" | translate
                    }}</mat-checkbox>
                <mat-label>{{ "Periodo de Validez" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <input required matInput #input type="number" name="message"
                        [readonly]="action === recordAction.View" formControlName="validityPeriod" placeholder="" />
                </mat-form-field>
                <mat-hint align="start"> {{ "Horas" | translate }}</mat-hint>

                <mat-checkbox [checked]="hasURL" [checked]="hasURL" disabled formControlName=""
                    (change)="hasUrl($event)">{{
                    "Agregar URL" | translate
                    }}</mat-checkbox>

                <div *ngIf="hasURL">
                    <mat-label>{{ "URL" | translate }}*</mat-label>
                    <mat-form-field appearance="outline" class="w-100-p">
                        <input matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                            formControlName="longUrl" placeholder="" />
                    </mat-form-field>
                </div>

                <button class="next-button" mat-raised-button matStepperNext>
                    <span class="material-icons-outlined mr-24">
                        navigate_next
                    </span>
                    {{ "Siguiente" | translate }}
                </button>
            </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
            <form [formGroup]="secondFormGroup">
                <ng-template matStepLabel>{{
                    "Calendarizar Envio" | translate
                    }}</ng-template>

                <mat-checkbox name="esRecurrente" formControlName="esRecurrente">{{ "Recurrente" | translate
                    }}</mat-checkbox>

                <section class="example-section" fxLayout="column">
                    <mat-label>{{ "Fecha de Inicio" | translate }}*</mat-label>
                    <mat-form-field appearance="outline" class="w-100-p">
                        <input formControlName="fechaInicio" matInput [matDatepicker]="picker" placeholder=""
                            [readonly]="action === recordAction.View" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-label *ngIf="esRecurrente">{{ "Fecha Final" | translate }}*</mat-label>
                    <mat-form-field appearance="outline" *ngIf="esRecurrente" class="w-100-p">
                        <input formControlName="fechaFin" matInput [matDatepicker]="picker2" placeholder=""
                            [readonly]="action === recordAction.View" />
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </section>
                <mat-label>{{ "Hora de envio" | translate }} ({{"hourFormat"| translate}})</mat-label>
                <section class="example-section-time-scheduler" fxLayout="row">
                    <div class="w-100-p">
                        <ngx-mat-timepicker-field controlOnly="true" name="time" formControlName="time" [format]="24"
                            placeholder="16:00"></ngx-mat-timepicker-field>
                    </div>
                    <div class="active-container-scheduler">
                        <mat-label>{{ "Activo" | translate }}</mat-label>
                        <mat-slide-toggle name="esActivo" formControlName="esActivo"></mat-slide-toggle>
                    </div>
                </section>
                <div style="height: 45px !important">
                    <section *ngIf="esRecurrente" class="example-section">
                        <mat-radio-group>
                            <mat-radio-button (change)="radioChange($event)" [checked]="checkedRadioButon === 1"
                                class="example-margin" value="1">{{
                                "Todos los dias" | translate
                                }}</mat-radio-button>
                            <mat-radio-button (change)="radioChange($event)" [checked]="checkedRadioButon === 3"
                                class="example-margin" value="3">{{
                                "Dias Especificos" | translate
                                }}</mat-radio-button>
                        </mat-radio-group>
                    </section>
                </div>

                <div style="height: 110px !important" *ngIf="checkedRadioButon === 3">
                    <section>
                        <section class="example-section-days">
                            <div>
                                <mat-checkbox name="lunes" formControlName="lunes" class="example-margin">{{ "Lunes" |
                                    translate }}</mat-checkbox>
                                <mat-checkbox name="jueves" formControlName="jueves" class="example-margin">{{ "Jueves"
                                    | translate }}</mat-checkbox>
                                <mat-checkbox name="domingo" formControlName="domingo" class="example-margin">{{
                                    "Domingo" | translate }}</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox name="martes" formControlName="martes" class="example-margin">{{ "Martes"
                                    | translate }}</mat-checkbox>
                                <mat-checkbox name="viernes" formControlName="viernes" class="example-margin">{{
                                    "Viernes" | translate }}</mat-checkbox>
                            </div>

                            <div>
                                <mat-checkbox name="miercoles" formControlName="miercoles" class="example-margin">{{
                                    "Miércoles" | translate }}</mat-checkbox>
                                <mat-checkbox name="sabado" formControlName="sabado" class="example-margin">{{ "Sábado"
                                    | translate }}</mat-checkbox>
                            </div>
                        </section>
                    </section>
                </div>

                <div class="buttons-container ">
                    <button mat-stroked-button matStepperPrevious class="back-button">
                        <span class="material-icons-outlined">
                            arrow_back_ios
                        </span>
                        {{ "Anterior" | translate }}
                    </button>
                    <button class="save-button-scheduler" [spinnerButton]="isWaiting"
                        *ngIf="action !== recordAction.View" mat-raised-button (click)="performAction()">
                        <span class="material-icons-outlined"> save </span>
                        {{ "Guardar" | translate }}
                    </button>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>

    <!-- Content -->
</wtf-dialogcontent>